export var createSizing = function createSizing(spacing) {
  return {
    drawerGutter: parseInt(spacing(1)) * 1.5 + "px",
    // 12
    footerHeight: spacing(7),
    // 56
    leftDrawerWidthOpen: spacing(37),
    // 296
    leftDrawerWidthClosed: spacing(8),
    // 64
    menuOffset: parseInt(spacing(-1)) / 2 + "px" // -4

  };
};